/** Internal */
import { gql } from "lib/apolloClient";

export const getOrganizationStudentsQuery = gql`
  query getOrganizationStudents(
    $id: ID!
    $studentFilters: OrgConnectionFilterInput
  ) {
    node(id: $id, type: ORGANIZATION) {
      id
      ... on Organization {
        id
        students(
          orderBy: FIRST_NAME
          orderByDirection: ASC
          filters: $studentFilters
        ) {
          edges {
            node {
              id
              firstName
              lastName
              profileImage
            }
          }
        }
      }
    }
  }
`;

export const getStudentSubjectsQuery = gql`
  query getStudentSubjects($id: ID!, $subjectFilters: SubjectFilter) {
    node(id: $id, type: STUDENT) {
      id
      ... on Student {
        id
        subjects(filters: $subjectFilters) {
          id
          name
          variants {
            level {
              id
              label
            }
          }
        }
      }
    }
  }
`;
